//TODO: this needs a better data structure, not happy with the two loops in the eventHandler.
//i think i might sacrifice creation time for event speed and unpack the component events a little bit.

export default function eventDelegator(ed) {
	const eventRegister = {};
	const boundEvents = {};
	const eventHandler = function (ed, e) {
		let eventType;
		let event;
		for (event in eventRegister) {
			if (eventRegister.hasOwnProperty(event) && eventRegister[event].isEnabled) {
				for (let i = 0, ii = eventRegister[event].events.length; i < ii; i++) {
					eventType = eventRegister[event].events[i];
					if (eventType.type.toLowerCase().indexOf(e.type) > -1) {
						if (eventType.shouldTrigger(ed, e)) {
							eventType.callback.apply(this, [e.target]);
						} else {
							eventType.missed && eventType.missed();
						}
					}
				}
			}
		}
	};

	return {
		//takes an array of {type: tinymceEvent, shouldTrigger: tagname|function(e.target), callback: function, missed: function()}
		addEventsForComponent(component, events) {
			if (!(component in eventRegister)) {
				eventRegister[component] = {};
				eventRegister[component].events = [];
				eventRegister[component].isEnabled = true;
			}
			for (let i = 0, ii = events.length; i < ii; i++) {
				!(events[i].type in boundEvents) &&
					(function () {
						boundEvents[events[i].type] = true;
						ed[events[i].type].add(eventHandler);
					})();
				if (!(typeof events[i].shouldTrigger === 'function')) {
					(function (triggerTag) {
						events[i].shouldTrigger = function (ed, e) {
							return e.target.tagName.toLowerCase() == triggerTag;
						};
					})(events[i].shouldTrigger);
				}
				eventRegister[component].events.push(events[i]);
			}
		},
		disableEventsForComponent(component) {
			for (let i = 0, ii = eventRegister.length; i < ii; i++) {
				if (component in eventRegister) {
					eventRegister[component].isEnabled = false;
					return true;
				}
			}
			return false;
		},
		enableEventsForComponent(component) {
			for (let i = 0, ii = eventRegister.length; i < ii; i++) {
				if (component in eventRegister) {
					eventRegister[component].isEnabled = true;
					return true;
				}
			}
			return false;
		},
	};
}
